import React, { useEffect, useState } from 'react'
import { CustomButton } from '../../../../../components/mui/CustomButton';
import DownloadIcon from '@mui/icons-material/Download';
import { useDispatch, useSelector } from 'react-redux';
import { mergeCGAFileCollectionDownloadRequest } from '../actions';
import { Modal, Row, Col } from 'react-bootstrap';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';
import { saveFileMergeStatusCGARequest } from '../actions';
import { Input, Typography, styled, Box } from '@mui/material';

const FileInputWrapper = styled(Box)(({ theme }) => ({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    border: '2px dashed var(--primary)',
    borderRadius: '8px',
    backgroundColor: 'var(--bg-body)',
    padding: '30px 20px',
    textAlign: 'center',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
        backgroundColor: 'var(--bg-hover)',
    },
}));

const HiddenInput = styled('input')({
    opacity: 0,
    position: 'absolute',
    inset: 0,
    cursor: 'pointer',
});

const FileText = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: 'var(--text-secondary)',
}));

const FileName = styled(Typography)(({ theme }) => ({
    fontSize: '15px',
    fontWeight: 500,
    color: 'var(--text-primary)',
    maxWidth: '90%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
}));

const FileDetails = styled(Box)(({ theme }) => ({
    marginTop: '8px',
    fontSize: '12px',
    color: 'var(--text-secondary)',
}));

const FileSize = styled(Typography)(({ theme }) => ({
    fontSize: '12px',
    color: 'var(--text-secondary)',
}));

const SelectAnotherFile = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    color: 'var(--primary)',
    cursor: 'pointer',
    marginTop: '8px',
    '&:hover': {
        textDecoration: 'underline',
    },
}));

const PageInputBox = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
}));

const StyledInput = styled(Input)(() => ({
    border: '1px solid var(--border)',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '14px',
    width: '80px',
    '& input': {
        textAlign: 'center',
    },
}));

const ActionTemplate = (rowData) => {
    const dispatch = useDispatch();
    const [totalPages, setTotalPages] = useState(0);
    const [file, setFile] = useState(null);
    const [open, setOpen] = useState(false);
    const { loading } = useSelector((state) => state.saveFileMergeStatusCGA);
    const formatFileSize = (size) => {
        if (size < 1024) return `${size} bytes`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };
    const handleMergeCGAFileCollectionDownload = () => {
        dispatch(mergeCGAFileCollectionDownloadRequest({ fileId: rowData?.Id, fileName: rowData?.UserFileName.split('.').slice(0, -1).join('.') }));
    }
    const handleSaveFileMergeStatusCGA = () => {
        dispatch(saveFileMergeStatusCGARequest({ AudioFileId: rowData?.Id, TotalPages: totalPages, File: file }));
    }
    useEffect(() => {
        if (!open) {
            setFile(null);
            setTotalPages(0);
        }
    }, [open]);
    if (rowData?.Status !== 'Done') {
        return <></>;
    }
    return (
        <div className="d-flex gap-2">
            <CustomButton size="icon" variant="icon" onClick={() => {
                handleMergeCGAFileCollectionDownload();
            }}>
                <DownloadIcon />
            </CustomButton>
            <CustomButton size="small" variant="primary" onClick={() => {
                setOpen(true);
            }}>
                Submit
            </CustomButton>
            <Modal
                show={open}
                onHide={() => {
                    if (!loading) {
                        setOpen(false);
                    }
                }}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div className="preview-dropdown-header d-flex justify-content-between align-items-center p-3">
                    <Typography variant="h6">Submit File</Typography>
                    <HighlightOffRoundedIcon
                        onClick={() => {
                            if (!loading) {
                                setOpen(false);
                            }
                        }}
                        className="cursor-pointer opacity-50"
                        style={{ height: '28px', width: '28px' }}
                    />
                </div>

                <div className="preview-dropdown-body p-3">
                    <Row>
                        <Col md="12" className="mb-3">
                            <FileInputWrapper>
                                <HiddenInput
                                    type="file"
                                    accept=".pdf,.doc,.docx,.txt"
                                    onChange={(e) => setFile(e.target.files[0])}
                                />
                                {file ? (
                                    <>
                                        <FileName>{file.name}</FileName>
                                        <FileDetails>
                                            <FileSize>{formatFileSize(file.size)}</FileSize>
                                        </FileDetails>
                                        <SelectAnotherFile onClick={() => {
                                            if (!loading) {
                                                setFile(null);
                                            }
                                        }}>
                                            Select another file
                                        </SelectAnotherFile>
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="body1" sx={{ color: 'var(--text-primary)' }}>
                                            Please select the file to submit.
                                        </Typography>
                                        <FileText>Click here to select the file</FileText>
                                    </>
                                )}
                            </FileInputWrapper>
                        </Col>

                        <Col md="12" className="mb-3">
                            <PageInputBox>
                                <Typography variant="body1" sx={{ color: 'var(--text-primary)' }}>
                                    Enter the total No of pages:
                                </Typography>
                                <StyledInput
                                    type="number"
                                    value={totalPages}
                                    onChange={(e) => setTotalPages(e.target.value)}
                                    placeholder="0"
                                />
                            </PageInputBox>
                        </Col>

                        <Col md="12" className="text-end">
                            <CustomButton
                                variant="primary"
                                color="primary"
                                onClick={handleSaveFileMergeStatusCGA}
                                disabled={totalPages === 0 || !file || loading}
                            >
                                Submit
                            </CustomButton>
                        </Col>
                    </Row>
                </div>
            </Modal>
        </div>
    )
}

export default ActionTemplate